import service from "@/store/services/products-service";
import Jsona from "jsona";

const jsona = new Jsona();

export const state = () => ({
  list: {},
  product: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, product) => {
    state.product = product;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((product) => {
      commit("SET_RESOURCE", product);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((product) => {
      commit("SET_RESOURCE", product);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((product) => {
      commit("SET_RESOURCE", product);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },

  getProductUnitOfMeasureUnitPrice({ commit, dispatch }, params) {
    return service.getProductUnitOfMeasureUnitPrice(params, this.$axios);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  product: (state) => state.product,
  url: (state) => state.url,
  dropdown: (state) => {
    return state.list.map((product) => ({
      id: product.id,
      name: product.name,
    }));
  },
};

const products = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default products;
